import { Logger } from "../logger/logger";
import { E2EHelper } from "../core/e2e-helper";
import { ResultLevel } from "../checkresultdialog/checkresultdata";
import { DateHelper } from "../helper/date-helper";

export enum MessageType {
	None = "",
	Success = "success",
	Warning = "warning",
	Error = "error"
}

interface IMessage {
	timestamp: Date;
	displayTime: number;
	message: string;
	messageType: MessageType;
}

export abstract class MessageHelper {
	public static messages: IMessage[] = [];

	public static defaultDisplayTime = 1000;
	public static offsetFix = { x: 0, y: -35 };
	public static spaceBetweenToasts = 40;

	public static getVisibleMessagesLengthAndRemoveOldMessages = () => {
		let curVisMessages = MessageHelper.messages.filter((msg) => msg && (msg.timestamp.getTime() + msg.displayTime) > DateHelper.nowAsDateWithTime().getTime());
		if (curVisMessages.length !== MessageHelper.messages.length) {
			// remove old messages
			MessageHelper.messages = curVisMessages;
		}
		return curVisMessages.length;
	}

	public static readonly uiSuccess = (message: string, displayTime?: number) => {
		MessageHelper.ui(message, MessageType.Success, displayTime);
		Logger.log(message);
	}

	public static readonly uiWarning = (message: string, displayTime?: number) => {
		if (!(displayTime > 0)) {
			displayTime = 3000;
		}
		MessageHelper.ui(message, MessageType.Warning, displayTime);
		Logger.warn(message);
	}

	public static readonly uiError = (message: string, displayTime?: number) => {
		if (!(displayTime > 0)) {
			displayTime = 5000;
		}
		MessageHelper.ui(message, MessageType.Error, displayTime);
		Logger.error(message);
	}

	public static readonly uiNotImplemented = (displayTime?: number) => {
		if (!(displayTime > 0)) {
			displayTime = 3000;
		}
		MessageHelper.ui("Not implemented", MessageType.Warning, displayTime);
		Logger.warn("Not implemented");
	}

	private static readonly ui = (message: string, messageType: MessageType, displayTime: number = MessageHelper.defaultDisplayTime) => {
		// tslint:disable-next-line:ban
		DevExpress.ui.notify({ position: { at: "center bottom", offset: `${MessageHelper.offsetFix.x} ${MessageHelper.offsetFix.y - (MessageHelper.spaceBetweenToasts * MessageHelper.getVisibleMessagesLengthAndRemoveOldMessages())}` }, message }, messageType, displayTime);
		MessageHelper.messages.push({ message, displayTime, timestamp: DateHelper.nowAsDateWithTime(), messageType });

		let severity: ResultLevel;
		switch (messageType) {
			case MessageType.Error:
				severity = ResultLevel.Error;
				break;
			case MessageType.Warning:
				severity = ResultLevel.Warning;
				break;
			case MessageType.Success:
				severity = ResultLevel.Ok;
				break;
			case MessageType.None:
			default:
				severity = ResultLevel.None;
				break;
		}

		E2EHelper.getInstance().trigger({ source: "toast", message, severity });
	}
}